import { render, staticRenderFns } from "./Notify.vue?vue&type=template&id=1255ba0a&scoped=true"
import script from "./notify.js?vue&type=script&lang=js&external"
export * from "./notify.js?vue&type=script&lang=js&external"
import style0 from "./notify.scss?vue&type=style&index=0&id=1255ba0a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1255ba0a",
  null
  
)

export default component.exports